import moment from 'moment';

import { BAYS } from '../../../../constants';

export const NEW_PROVIDER_ASSIGNMENT_ID = -1;

export const LABELS = {
  1: 'Started',
  2: 'Completed',
  3: 'Editing',
  4: 'Read Only',
} as const;

export const NEW_ASSIGNMENT_WITHOUT_CLIENT = {
  provider: {
    id: 0,
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    middle_name: '',
    sex: '',
    dob: '',
    street_address_line_one: '',
    street_address_line_two: '',
    street_address_city: '',
    street_address_state: '',
    street_address_zip: 0,
    npi: '',
    certification: '',
    state_license: 'string',
    provider_type: '',
  },
  clinical_relationship: null,
  date_start: null,
  date_end: null,
} as const;

export const NEW_COHORT_ASSIGNMENT_WITHOUT_CLIENT = {
  cohort: {
    name: BAYS.BAY_2_6,
    service_classes: [],
    client_assignments: [],
  },
  date_start: moment(new Date()).format('YYYY-MM-DD'),
  date_end: null,
};

export const NEW_FACILITY_ASSIGNMENT_WITHOUT_CLIENT = {
  facility: {
    label: '',
    facility_type: '',
    street_address_line_one: '',
    street_address_line_two: '',
    street_address_city: '',
    street_address_state: '',
    street_address_zip: '',
    phone: '',
    is_active: false,
    npi: '',
    tin: '',
    clearinghouse_facility_id: '',
    clearinghouse_facility_name: '',
    clearinghouse_facility_type: '',
  },
  assignment_type: null,
  date_start: new Date(),
  date_end: new Date(),
} as const;
